import { atom } from "recoil";

export const instanceIdAtom = atom<undefined | string>({
	key: 'instance-id',
	default: undefined
});

export const currentAppAtom = atom<string>({
	key: 'app-id',
	default: 'areax'
});


export const tokenAtom = atom<undefined | string>({
	key: 'token',
	default: undefined
});

export const pinAtom = atom<undefined | number>({
	key: 'pin',
	default: undefined
});

export const maxTime = 3 * 60 * 1000; // 3 minutes 

export const residueTimeAtom = atom<number>({
	key: 'residue-time',
	default: maxTime
});

export const timerRunningAtom = atom<boolean>({
	key: 'timer-running',
	default: false
});


interface IPlayedAdio {
	[key: string]: boolean;
}

export const playedAudioAtom = atom<IPlayedAdio>({
	key: 'played-audio',
	default: {}
});

export const commandsErrorsAtom = atom<number>({
	key: 'commands-errors',
	default: 0
});